import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'genericFilter',
    pure: false
})
export class GenericFilterPipe implements PipeTransform {
    transform(items: any[], callback: (item: any) => boolean): any {
        if (!items || !callback) {
            return items;
        }
        return items.filter(item => callback(item));
    }
}


// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/pipes/generic.filter.pipe.ts